import React from 'react';
import styles from './loadingSkeleton.module.scss';
import classNames from 'classnames';

type LoadingSkeletonColorType = 'light' | 'dark';

export type LoadingSkeletonProps = React.HTMLAttributes<HTMLDivElement> & {
  /**
   * If 'true', LoadingSkeleton has a round shape, 'false' by default
   */
  rounded?: boolean;
  /**
   * Height of the LoadingSkeleton
   */
  height?: number | string;
  /**
   * Width of the LoadingSkeleton
   */
  width?: number | string;
  /**
   * LoadingSkeleton color, 'light' by default
   */
  color?: LoadingSkeletonColorType;
  /**
   * CSS styles to override LoadingSkeleton
   */
  style?: React.CSSProperties;
  /**
   * override component border-radius
   */
  customBorderRadius?: number | string;
};

export const LoadingSkeleton = (props: LoadingSkeletonProps) => {
  const { color = 'light', rounded = false, height, width, style, className, customBorderRadius, ...other } = props;

  const customStyles: React.CSSProperties = {
    borderRadius: customBorderRadius || (rounded ? '50%' : '3px'),
    ...(height !== undefined ? { height } : {}),
    ...(width !== undefined ? { width } : {}),
    ...style,
  };

  return <div className={classNames(styles.skeleton, styles[color], className)} style={customStyles} {...other}></div>;
};
